import { render, staticRenderFns } from "./AddNamspaceForm.vue?vue&type=template&id=81d3c588"
import script from "./AddNamspaceForm.vue?vue&type=script&lang=js"
export * from "./AddNamspaceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports